"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVideoEnabled = void 0;
const rxjs_1 = require("./rxjs");
const rxjs_2 = require("rxjs");
const operators_1 = require("rxjs/operators");
function useVideoEnabled(videoController) {
    const enabled = videoController.pipe((0, operators_1.switchMap)(controller => {
        var _a;
        return (_a = controller === null || controller === void 0 ? void 0 : controller.enabled) !== null && _a !== void 0 ? _a : (0, rxjs_2.of)(false);
    }));
    return (0, rxjs_1.useObservable)(enabled);
}
exports.useVideoEnabled = useVideoEnabled;
//# sourceMappingURL=use_video_enabled.js.map